import { Configurable, environment } from "@crystal/config";
import { getCookies, isBrowser, getFrontendId } from "@crystal/core";
const MF_SERVER_COOKIE = "CRYSTAL_MF_SERVER";
const mfServerOverride = new Configurable((context) => {
  const mfServerValue = getCookies()[MF_SERVER_COOKIE];
  if (mfServerValue && context.env !== "prod") {
    return mfServerValue;
  }
});
const mfServer = environment({
  local: "http://localhost:8700",
  development: getBranchMfServer(),
  staging: "https://stg.account-frontends.adidas.com",
  production: "https://account-frontends.adidas.com"
}).chain((value) => mfServerOverride.chain((override) => override || value));
function createClientConfig({ name, version }) {
  const config = Configurable.props({
    mfId: getFrontendId(name, version),
    mfServer
  });
  return config;
}
function getBranchMfServer() {
  if (isBrowser() && ["localhost", "3stripes.net"].includes(location.origin)) {
    return location.origin.replace("storybook", "frontends");
  }
  return "https://dev.account-frontends.adidas.com";
}
export {
  createClientConfig,
  mfServer
};
//# sourceMappingURL=utils.js.map
